import { render } from "./MailSender.vue?vue&type=template&id=42412099&scoped=true&ts=true"
import script from "./MailSender.vue?vue&type=script&lang=ts"
export * from "./MailSender.vue?vue&type=script&lang=ts"

import "./MailSender.vue?vue&type=style&index=0&id=42412099&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42412099"]])

export default __exports__